import type { InnogyComponentRendering } from '@core/jss-models';
import type {
  ImageField,
  LinkField,
  RichTextField,
  TextField,
} from '@core/jss-proxy';

export enum HERO_TYPES {
  HERO = 'Hero',
  HERO_MINIMAL = 'HeroMinimal',
  HERO_WITH_WIDGET = 'HeroWithWidget',
  HERO_WITH_APP_BUTTONS = 'HeroWithAppButtons',
  HERO_WITH_ASSET = 'HeroWithAsset',
}

export enum HERO_FIELDS {
  ANDROID_BUTTON = 'androidButton',
  BACKGROUND_IMAGE = 'backgroundImage',
  BACKGROUND_IMAGE_POSITION = 'backgroundImagePosition',
  BACKGROUND_IMAGE_REPEAT = 'backgroundImageRepeat',
  BACKGROUND_IMAGE_SIZE = 'backgroundImageSize',
  BACKGROUND_IMAGE_MOBILE = 'backgroundImageMobile',
  BACKGROUND_IMAGE_MOBILE_POSITION = 'backgroundImageMobilePosition',
  BACKGROUND_IMAGE_MOBILE_REPEAT = 'backgroundImageMobileRepeat',
  BACKGROUND_IMAGE_MOBILE_SIZE = 'backgroundImageMobileSize',
  BOTTOM_IMAGE = 'bottomImage',
  BOTTOM_IMAGE_MOBILE = 'bottomImageMobile',
  HEADING_LINE1 = 'headingLine1',
  HEADING_LINE2 = 'headingLine2',
  MAIN_IMAGE = 'mainImage',
  PARAGRAPH = 'paragraph',
  PRIMARY_BUTTON = 'primaryButton',
  RICH_TEXT = 'richText',
  SECONDARY_BUTTON = 'secondaryButton',
  USE_BACKGROUND_IMAGE_ON_MOBILE = 'useBackgroundImageOnMobile',
  USE_BOTTOM_IMAGE_ON_MOBILE = 'useBottomImageOnMobile',
  WIDGET = 'widget',
}

export type HeroBackgroundImage = {
  image?: ImageField;
  position?: string;
  repeat?: string;
  size?: string;
  useOnMobile?: boolean;
};

export type Hero = {
  headingLine1: TextField;
  headingLine2?: TextField;
  primaryButton?: LinkField;
  secondaryButton?: LinkField;
  backgroundImage?: HeroBackgroundImage;
  backgroundImageMobile?: HeroBackgroundImage;
  mainImage?: ImageField;
  bottomImage?: ImageField;
  bottomImageMobile?: ImageField;
  useBottomImageOnMobile?: boolean;
  paragraph?: TextField;
  richText?: RichTextField;
  widget?: InnogyComponentRendering;
  googlePlayButton?: LinkField;
  appStoreButton?: LinkField;
};

export type HeroAppButton = {
  alt: string;
  type: 'ios-app-store' | 'google-play-store';
  src: string;
  url: string;
};
